import { Form } from "react-bootstrap";
import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";
import { addData, getData } from "./utils";

interface IFormTextareaProps extends IFormInputDefault{
  rows?:number;
}

export default function FormTextarea({
  title,
  name,
  state,
  onChange,
  rows = 3,
  ...props
}:IFormTextareaProps){

  
  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name;
    props_aux["defaultValue"] = state.model?getData(state.model,name):"";
  }

  return (
    <BodyInputFormat props={{...props,title}}>
      <Form.Control size="sm"
        as="textarea"
        rows={rows}
        onChange={(event)=>{
          if(state && name){
            let value = event.target.value;

            state.setModel((old:any)=>{
              return addData(old,name,value);
            });
          }if(onChange)onChange(event)
        }} 
        {...props_aux}
      />
    </BodyInputFormat>
  );
}